import React, { useEffect, useMemo, useState } from "react";
import { Table, Button, Modal, List, Avatar, Popover, Drawer, InputNumber } from "antd";
import TitleComp from "../components/Title/title";
import { useDrawer } from "../context/drawer";
import DrawerComp from "../components/Drower/Drawer";
import { useSelector } from "react-redux";
import axios from "axios";
import moment from "moment";
import { FaRegEye } from "react-icons/fa";
import { FaBoxOpen } from "react-icons/fa6";
import { MdCancel } from "react-icons/md";
import { Form, Input } from "antd";
export default function EnachDetail() {
  const columns = [
    {
      title: "Order ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "User Name",
      dataIndex: "user",
      key: "user_name",
      render: (user) => user?.user_name || "N/A",
    },
    {
      title: "Address",
      dataIndex: "full_address",
      key: "full_address",
    },
    {
      title: "Phone Number",
      dataIndex: "phone_number",
      key: "phone_number",
    },
    {
      title: "Order Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        let color = "black"; // Default color
        if (status.toLowerCase() === "success") color = "green";
        else if (status.toLowerCase() === "pending") color = "orange";
        else if (status.toLowerCase() === "failed") color = "red";

        return <span style={{ color, fontWeight: "bold", textTransform: "capitalize" }}>{status}</span>;
      },
    },
    {
      title: "Transaction ID",
      dataIndex: "order_id",
      key: "order_id",
    },
    {
      title: "Order Amount",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Tax Amount",
      dataIndex: "tax_amount",
      key: "tax_amount",
    },
    {
      title: "Tracking Id",
      dataIndex: "tracking_id",
      key: "tracking_id",
    },
    {
      title: "Subtotal",
      dataIndex: "subtotal",
      key: "subtotal",
    },
    {
      title: "View Product",
      key: "view_invoice",
      render: (_, record) => (
        <div className="order-view-product-main-con" onClick={() => showProductModal(record)}>
          <div className="order-view-product bg-primary">
            <FaRegEye />
          </div>
        </div>
      ),
    },
    {
      title: "Create Shipping",
      render: (_, record) => (
        <div className="order-view-product-main-con">
          {record.tracking_id === "0" || !record.tracking_id ? (
            <div
              className="order-view-product bg-success"
              onClick={() => handleOpenShippingModal(record)}
            >
              <FaBoxOpen />
            </div>
          ) : (
            <div style={{ display: "flex", gap: "10px" }}>
              <div className="order-view-product-main-con">
                <Popover title="Cancel Shipping" overlayStyle={{ width: "auto" }}>
                  <div
                    className="order-view-product  bg-danger"
                    onClick={() => handleCancelShipping(record)}
                  >
                    <MdCancel />
                  </div>
                </Popover>
              </div>
              <div className="order-view-product-main-con">
                <Popover title="Check Shipping Status">
                  <div
                    className="order-view-product "
                    onClick={() => handleCheckShippingStatus(record)}
                  >
                    <FaBoxOpen />
                  </div>
                </Popover>
              </div>
            </div>
          )}
        </div>
      ),
    }
  ];

  const [fetchList, setFetchList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalData, setTotalData] = useState(0);
  const { drawerData, setDrawerData } = useDrawer();
  const { token } = useSelector((state) => state.auth);
  const [productModalVisible, setProductModalVisible] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [shippingModalVisible, setShippingModalVisible] = useState(false);
  const [shippingForm] = Form.useForm();
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [open, setOpen] = useState(false);

  // const showDrawer = (order) => {
  //   setOrderDetails(order);
  //   setOpen(true);
  // };
  const onClose = () => {
    setOpen(false);
  };


  // Function to fetch data from the updated API
  const fetchData = async (page, limit) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `https://1fiveglobal.com/api/orders.php?action=fetch_all&admin_token=OdRLLsX46k3L8EwZgpNlVK5tKiRaghecPNH&limit=${limit}&page=${page}`
      );

      if (response.data.orders) {
        const updatedData = response.data.orders.map((order) => ({
          ...order,
          full_address: `${order.address.address}, ${order.address.city}, ${order.address.state} - ${order.address.pincode}`,
          phone_number: order.address.alternative_number,
          created_at: moment(order.created_at).format("llll"),
        }));
        setFetchList(updatedData);
        setTotalData(response.data.orders.length || 0);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching orders", error);
    }
  };

  useEffect(() => {
    fetchData(currentPage, pageSize);
  }, [currentPage, pageSize]);

  // Function to handle modal visibility and product data
  const showProductModal = (products) => {
    setSelectedProducts(products);
    setProductModalVisible(true);
    setOpen(true)
  };

  const handleModalClose = () => {
    setProductModalVisible(false);
    setSelectedProducts([]);
  };

  const handleOpenShippingModal = (order) => {
    console.log("order", order)
    setSelectedOrder(order);
    shippingForm.setFieldsValue({
      user_name: order?.user?.user_name || "",
      user_email: order?.user?.user_email || "",
      user_phone: order?.user?.user_phone || "",
      pincode: order?.address?.pincode || "",
      Breadth: 0,
      Count: 1,
      Height: 0,
      Length: 0,
    });
    setShippingModalVisible(true);
  };



  const handleCreateShipping = async () => {
    try {
      const values = await shippingForm.validateFields(); // Get validated form values

      if (!selectedOrder) {
        console.error("No order selected");
        return;
      }

      const currentDate = new Date();
      const epochTimestamp = `/Date(${currentDate.getTime()})/`;

      // Prepare requestData dynamically
      const requestData = {
        action: "generateWaybill",
        ConsigneeAttention: selectedOrder?.user?.user_name,
        ConsigneeEmailID: selectedOrder?.user?.user_email,
        ConsigneeMobile: selectedOrder?.user?.user_phone,
        ConsigneePincode: selectedOrder?.address?.pincode,
        ReturnEmailID: selectedOrder?.user?.user_email,
        ReturnMobile: selectedOrder?.user?.user_phone,
        ReturnPincode: selectedOrder?.address?.pincode,
        PickupDate: epochTimestamp,
        CustomerEmailID: selectedOrder?.user?.user_email,
        CustomerMobile: selectedOrder?.user?.user_phone,
        CustomerPincode: selectedOrder?.address?.pincode,
        Breadth: String(values.Breadth),
        Count: String(values.Count),
        Height: String(values.Height),
        Length: String(values.Length)
      };

      console.log("Request Data:", JSON.stringify(requestData, null, 2));

      const response = await axios.post(
        "https://1fiveglobal.com/api/newblue.php",
        requestData,
        { headers: { "Content-Type": "application/json" } }
      );
      console.log("Shipping created successfully", response);
      if (response.status >= 200 && response.status <= 300) {
        console.log("Shipping created successfully", response);
        fetchData();

        const trackingId = response.data?.response?.GenerateWayBillResult?.AWBNo;
        if (!trackingId) {
          console.error("Tracking ID not found in response");
          return;
        }

        // Update order with tracking ID
        const formData = new FormData();
        formData.append("action", "update");
        formData.append("order_id", selectedOrder?.order_id);
        formData.append("tracking_id", trackingId);
        formData.append("admin_token", "OdRLLsX46k3L8EwZgpNlVK5tKiRaghecPNH");

        const updateResponse = await axios.post(
          "https://1fiveglobal.com/api/orders.php",
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        if (updateResponse.status >= 200 && updateResponse.status <= 300) {
          console.log("Order updated successfully with tracking ID", updateResponse.data);
          fetchData();
        } else {
          console.error("Failed to update order", updateResponse.data);
        }
      } else {
        console.error("Failed to create shipping", response.data);
      }

      setShippingModalVisible(false); // Close modal after success
      shippingForm.resetFields(); // Reset form fields

    } catch (error) {
      console.error("Error creating shipping or updating order", error);
    }
  };




  const handleCancelShipping = async (record) => {
    if (!record?.tracking_id) {
      console.error("Error: No tracking ID found for this order.");
      return;
    }

    const requestData = {
      action: "cancelShipment",
      awbNo: record.tracking_id, // Ensure tracking_id exists
    };

    try {
      const response = await axios.post(
        "https://skdm.in/server/onefiveapi/newblue.php",
        requestData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status >= 200 && response.status < 300) {
        console.log("Shipping canceled successfully:", response.data);
        fetchData()
        // Optionally refresh the order list or update UI
      } else {
        console.error("Failed to cancel shipping:", response.data);
      }
    } catch (error) {
      console.error("Error canceling shipping:", error.message);
    }
  };



  // calculate ammount 
  const { roundedBasePrice, totalTax } = useMemo(() => {
    if (selectedProducts?.products?.length > 0) {
      const basePrice = Math.round(selectedProducts?.subtotal / 1.18);
      const tax = Math.round(selectedProducts?.subtotal - basePrice);
      return { roundedBasePrice: basePrice, totalTax: tax };
    }
    return { roundedBasePrice: 0, totalTax: 0 };
  }, [selectedProducts]);



  // shipping details 

  const [shippingStatusModalVisible, setShippingStatusModalVisible] = useState(false);
  const [shippingStatusData, setShippingStatusData] = useState(null);

  const handleCheckShippingStatus = async (record) => {
    try {
      const response = await axios.get(
        `https://skdm.in/server/onefiveapi/newblue.php?trackingNumber=${record.tracking_id}`
      );
      const parseXML = (xmlString) => {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(xmlString, "text/xml");
        return xmlDoc;
      };
      console.log("response",parseXML(response.data))

    

      if (result?.ShipmentData?.Shipment) {
        setShippingStatusData(result.ShipmentData.Shipment[0]);
        setShippingStatusModalVisible(true);
      } else {
        console.error("Shipment data not found in XML response.");
      }
    } catch (error) {
      console.error("Error fetching shipping status:", error);
    }
  };



  const ShippingStatusModal = ({ visible, onCancel, data }) => {
    if (!data) return null;

    return (
      <Modal
        title="Shipping Status"
        visible={visible}
        onCancel={onCancel}
        footer={[
          <Button key="close" onClick={onCancel}>
            Close
          </Button>,
        ]}
      >
        <List>
          <List.Item>
            <strong>Ref No:</strong> {data.$.RefNo}
          </List.Item>
          <List.Item>
            <strong>Waybill No:</strong> {data.$.WaybillNo}
          </List.Item>
          <List.Item>
            <strong>Service:</strong> {data.Service[0]}
          </List.Item>
          <List.Item>
            <strong>Pick Up Date:</strong> {data.PickUpDate[0]}
          </List.Item>
          <List.Item>
            <strong>Pick Up Time:</strong> {data.PickUpTime[0]}
          </List.Item>
          <List.Item>
            <strong>Origin:</strong> {data.Origin[0]}
          </List.Item>
          <List.Item>
            <strong>Destination:</strong> {data.Destination[0]}
          </List.Item>
          <List.Item>
            <strong>Product Type:</strong> {data.ProductType[0]}
          </List.Item>
          <List.Item>
            <strong>Sender Name:</strong> {data.SenderName[0]}
          </List.Item>
          <List.Item>
            <strong>To Attention:</strong> {data.ToAttention[0]}
          </List.Item>
          <List.Item>
            <strong>Weight:</strong> {data.Weight[0]}
          </List.Item>
          <List.Item>
            <strong>Status:</strong> {data.Status[0]}
          </List.Item>
          <List.Item>
            <strong>Expected Delivery Date:</strong> {data.ExpectedDeliveryDate[0]}
          </List.Item>
          <List.Item>
            <strong>Status Date:</strong> {data.StatusDate[0]}
          </List.Item>
          <List.Item>
            <strong>Status Time:</strong> {data.StatusTime[0]}
          </List.Item>
          <List.Item>
            <strong>Received By:</strong> {data.ReceivedBy[0]}
          </List.Item>
          <List.Item>
            <strong>Instructions:</strong> {data.Instructions[0]}
          </List.Item>
          <List.Item>
            <strong>Scans:</strong>
            <List
              dataSource={data.Scans[0].ScanDetail}
              renderItem={(scan) => (
                <List.Item>
                  <List.Item.Meta
                    title={scan.Scan[0]}
                    description={`Date: ${scan.ScanDate[0]}, Time: ${scan.ScanTime[0]}, Location: ${scan.ScannedLocation[0]}`}
                  />
                </List.Item>
              )}
            />
          </List.Item>
        </List>
      </Modal>
    );
  };


  return (
    <div>
      <TitleComp name="Order Lists" totalData={totalData} type="Order" />
      <Table
        columns={columns}
        dataSource={fetchList}
        loading={loading}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          total: totalData,
          showSizeChanger: true,
          onChange: (page, pageSize) => {
            setCurrentPage(page);
            setPageSize(pageSize);
          },
        }}
        rowKey="id"
      />
      <DrawerComp />

      <Modal
        title="Create Shipping"
        visible={shippingModalVisible}
        onCancel={() => setShippingModalVisible(false)}
        onOk={handleCreateShipping}
      >
        <Form form={shippingForm} layout="vertical">
          <Form.Item name="user_name" label="User Name" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="user_email" label="User Email" rules={[{ required: true, type: "email" }]}>
            <Input />
          </Form.Item>
          <Form.Item name="user_phone" label="User Phone" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="pincode" label="Pincode" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="Count" label="Count" rules={[{ required: true }]}>
            <Input disabled/>
          </Form.Item>
          <Form.Item
            name="Breadth"
            label="Breadth"
            rules={[{ required: true, type: "number", min: 0.1, message: "Breadth must be greater than 0" }]}
          >
            <InputNumber step={0.1} />
          </Form.Item>

          <Form.Item
            name="Height"
            label="Height"
            rules={[{ required: true, type: "number", min: 0.1, message: "Height must be greater than 0" }]}
          >
            <InputNumber step={0.1} />
          </Form.Item>

          <Form.Item
            name="Length"
            label="Length"
            rules={[{ required: true, type: "number", min: 0.1, message: "Length must be greater than 0" }]}
          >
            <InputNumber step={0.1} />
          </Form.Item>
        </Form>
      </Modal>




      {/* productdetails view modal  */}

      <Drawer title="Order Details" onClose={onClose} open={open}>
        {selectedProducts && (
          <>
            <section className='Order-Details-Drawer'>
              <div className='Order-Details-Drawer-Details-order-Id'>
                <div className='Order-Details-First-Part'>
                  <div className='row'>
                    <div className='col-5'>
                      <div className='Order-DetailsName'>
                        <h2>Ordet Date</h2>
                      </div>
                    </div>
                    <div className='col-7'>
                      <div className='Order-Details-dec'>
                        <h3>{moment(selectedProducts?.created_at).format("llll")}</h3>
                      </div>
                    </div>
                  </div>
                </div>


                <div className='Order-Details-First-Part'>
                  <div className='row'>
                    <div className='col-5'>
                      <div className='Order-DetailsName'>
                        <h2>order</h2>
                      </div>
                    </div>
                    <div className='col-7'>
                      <div className='Order-Details-dec'>
                        <h3>{selectedProducts?.order_id}</h3>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='Order-Details-First-Part'>
                  <div className='row'>
                    <div className='col-5'>
                      <div className='Order-DetailsName'>
                        <h2>Ordet total</h2>
                      </div>
                    </div>
                    <div className='col-7'>
                      <div className='Order-Details-dec'>
                        <h3>Rs. {selectedProducts?.amount}</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='Order-Details-Drawer-Details-order-Id'>
                <div className='Order-Details-Drawer-HeadDetails'>
                  <h2>Shipment details</h2>
                </div>
                {
                  selectedProducts && selectedProducts?.products?.map((elem) => {
                    const { details, images, product_size, product_price, product_qty, sizes } = elem
                    return (
                      <>
                        <div className='Order-details-Drawer-Shipment-details'>
                          <div className='row'>
                            <div className='col-4'>
                              <div className='Order-details-Drawer-Product-Image'>
                                <img src={images[0]?.images} />
                              </div>
                            </div>
                            <div className='col-8'>
                              <div className='Order-details-Drawer-Product-Details'>
                                <h3>{details?.product_name}</h3>
                                <h4>Qty: <span>{product_qty}</span></h4>
                                <h4>Price: <span>{product_price}</span></h4>
                                <h4>Size: <span>{sizes[0]?.product_size}</span></h4>
                              </div>
                            </div>

                          </div>
                        </div>
                      </>
                    )
                  })
                }
              </div>
              <div className='Order-Details-Drawer-Details-order-Id'>
                <div className='Order-Details-Drawer-HeadDetails'>
                  <h2>Payment Methods</h2>
                  <p>Online</p>
                </div>
                <div className='Order-details-Drawer-Shipment-details'>
                  <div className='Order-details-Drawer-Product-Details'>
                    <h3>{selectedProducts?.user?.user_name}</h3>
                    <p>{selectedProducts?.address?.address}</p>
                    <p>{selectedProducts?.address?.alternative_number}</p>
                    <p>{selectedProducts?.address?.city}, {selectedProducts?.address?.state}, {selectedProducts?.address?.pincode}</p>
                  </div>
                </div>
              </div>
              <div className='Order-Details-Drawer-Details-order-Id'>
                <div className='Order-Details-Drawer-HeadDetails'>
                  <h2>Order Summary</h2>
                </div>
                <div className='Order-details-Drawer-Shipment-details'>
                  <div className='Order-details-Drawer-Product-Details'>
                    <div className='row'>
                      <div className='col-7'>
                        <div className='Order-details-Drawer-payment-details'>
                          <h3>Subtotal:</h3>
                        </div>
                      </div>
                      <div className='col-5'>
                        <div className='Order-details-Drawer-payment-number'>
                          <h4>{roundedBasePrice}/- Rs</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='Order-details-Drawer-Product-Details'>
                    <div className='row'>
                      <div className='col-7'>
                        <div className='Order-details-Drawer-payment-details'>
                          <h3>Tax:</h3>
                        </div>
                      </div>
                      <div className='col-5'>
                        <div className='Order-details-Drawer-payment-number'>
                          <h4>{totalTax}/- Rs</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='Order-details-Drawer-Product-Details'>
                    <div className='row'>
                      <div className='col-7'>
                        <div className='Order-details-Drawer-payment-details'>
                          <h3 className='Order-details-Drawer-OrderTotal'>Total Amount:</h3>
                        </div>
                      </div>
                      <div className='col-5'>
                        <div className='Order-details-Drawer-payment-number'>
                          <h4 className='Order-details-Drawer-Orderamount'>{selectedProducts?.amount}/- Rs</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </>

        )}
      </Drawer>

      <ShippingStatusModal
        visible={shippingStatusModalVisible}
        onCancel={() => setShippingStatusModalVisible(false)}
        data={shippingStatusData}
      />
    </div>
  );
}
